import React from 'react'

export default function LeadTipsCard() {
  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-xs">
        <div className="flex items-center gap-3 border-b border-outline-variant/15 pb-4 mb-4">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-lg">lightbulb</span>
          </div>
          <div>
            <h3 className="font-display text-sm font-bold text-on-surface">
              Enquiry Form Settings
            </h3>
            <p className="text-[11px] font-bold text-primary">Tips:</p>
          </div>
        </div>

        <ul className="flex flex-col gap-3.5 text-xs text-on-surface-variant leading-relaxed">
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              check_circle
            </span>
            <span>
              With EdifyERP, you can create an Lead Form and allow students/parents who visit your institute to fill their details themselves.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              link
            </span>
            <span>
              You can access the lead form from <span className="font-semibold text-primary">www.edifyerp.com/Leads.aspx</span> . You can point your domain or sub-domain to this url.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              tablet
            </span>
            <span>
              Lead form can be used from PC or mobile but we recommend that you use low cost tablets.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              tune
            </span>
            <span>
              To customize the lead form as per your needs, please enable or disable desired fields and mark important fields as mandatory.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              edit
            </span>
            <span>
              You can also change default field name as per your choice.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              image
            </span>
            <span>
              Logo can be uploaded from [WebSite] menu option.
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}
